import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import { Button } from 'devextreme-react/button';
import HistoricalOrderTabs from "./HistoricalOrderTabs";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
import SaleOrderDataEntryPopup from "../../salesOrderDataEntry/common/SaleOrderDataEntryPopup";
import SalesOrderOptionsButton, { OptionsTabType } from "../common/SalesOrderOptionsButton";
import PrintReportMenu from "../common/PrintReportMenu";
const HistoricalOrderSearchResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "624ce7e1-795b-466a-a233-c3d4e77ed874";
    const childRef = useRef();
    const [currentLayout, setCurrentLayout]= useState("Default");
    const [showPopup, setShowPopup] = useState({id:null,visible:false});
    const [selectedCustomerId, setSelectedCustomerId] = useState(null);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const onSelectionChanged = ({ selectedRowsData }) => {
        const selectedRowData = selectedRowsData[0];
        if (childRef.current) {
            childRef.current.updateData(selectedRowData);
          }
          setSelectedCustomerId(selectedRowData?.rCustomer ?? null);
          setSelectedRecord(selectedRowData);
          setShowPopup({id:selectedRowData.rowid,visible:false});
    };

    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
             ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                onSelectionChanged={onSelectionChanged}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single"  />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <FilterRow visible={true} />
                <Column dataField="recordNumber" caption='Record#' ></Column>
                <Column dataField="identityID" caption='Customer' ></Column>
                <Column dataField="customerName" caption='Name' ></Column>
                <Column dataField="transactiontype" caption='Type' ></Column>
                <Column dataField="transactionnumber" caption='Transaction.#' ></Column>
                <Column dataField="transactiondate" dataType="date" format="MM/dd/yyyy" caption='Order Date' ></Column>
                <Column dataField="shippingdate" dataType="date" format="MM/dd/yyyy" caption='Ship Date' ></Column>
                <Column dataField="fiscalperiod" caption='FP' ></Column>
                <Column dataField="fiscalyear" caption='FY' ></Column>
                <Column dataField="itemTotal" caption='ItemTotal' ></Column>
                <Column dataField="city" caption='City' ></Column>
                <Column dataField="transactionduedate" visible={false} caption='Transaction duedate'></Column>
                <Column dataField="purchaseordernumber" visible={false} caption='PO.#'></Column>
                <Column dataField="pricelevel" visible={false} caption='Pricelevel'></Column>
                <Column dataField="discounttype" visible={false} caption='Discount type'></Column>
                <Column dataField="discountpercent" visible={false} caption='DiscountPercent'></Column>
                <Column dataField="consigneeName" visible={false} caption='Consignee Name'></Column>
                <Column dataField="consigneeAddress1" visible={false} caption='ConsigneeAddress1'></Column>
                <Column dataField="consigneeAddress2" visible={false} caption='ConsigneeAddress2'></Column>
                <Column dataField="consigneeCity" visible={false} caption='ConsigneeCity'></Column>
                <Column dataField="consigneeZip" visible={false} caption='ConsigneeZip'></Column>
                <Column dataField="consigneeState" visible={false} caption='ConsigneeState'></Column>

                <Toolbar>
                 <Item location="before">
                     <Button text="Edit" disabled={!showPopup.id} type="default" onClick={()=>setShowPopup(prevFormData=>({...prevFormData, visible:true}))} />
                 </Item>
                <Item location="before">
                     <Button text="Add" type="default" onClick={()=>setShowPopup({id:null, visible:true})}/>
                    </Item>
                    <Item location="before">
                    <PrintReportMenu selectedRecord={selectedRecord} />
                    </Item>
                    <Item location="before">
                    <SalesOrderOptionsButton tabType={OptionsTabType.Order} customerId={selectedCustomerId} />
                    </Item>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
            <HistoricalOrderTabs ref={childRef} accessToken={accessToken} />
            <SaleOrderDataEntryPopup showPopup={showPopup} setShowPopup={setShowPopup}/>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(HistoricalOrderSearchResult);